import { apiClient } from '@/shared/api';

import type { SimulateRequest, SimulateResponse } from '../model/types';

const BASE = '/api/v1/catalog/promo/simulate';

/** Evaluate a test cart against DRAFT/ACTIVE promotions — side-effect-free (`view` is enough). */
export const simulatePromoCart = async (body: SimulateRequest): Promise<SimulateResponse> =>
  (await apiClient.post<SimulateResponse>(BASE, body)).data;
